import React, { useState } from 'react';
import { Query } from 'react-apollo';
import { useAuthService } from '@/contexts/authService';
import HeaderMenuDiscovery from './component';
import { headerStackedListBreakpoint } from '../../base-styles/vars';
import {
  UserQueryPrivate,
  UserQueryPublicBasic,
} from '../../state/services/gql/user';
import {
  getHash,
  getObjFromHashParamString,
  updateHash,
} from '../../utils/urls';
import MyEventsProductMarketingModal from '../../containers/MyEventsProductMarketingModal';

const hashObj = getObjFromHashParamString(getHash());

const HeaderMenuDiscoveryContainer = ({ data, ...props }) => {
  const authService = useAuthService();
  const [categoriesVisible, setCategoriesVisible] = useState(false);
  const [navVisible, setNavVisible] = useState(false);
  const [searchVisible, setSearchVisible] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const toggleNavVisibility = () => {
    setNavVisible(!navVisible);
    setCategoriesVisible(false);
  };

  const handleButtonClick = (event) => {
    const target = event?.target;

    if (target) {
      target.blur();
    }

    toggleNavVisibility();
  };

  const toggleCategoriesVisibility = () => {
    setCategoriesVisible(!categoriesVisible);
  };

  const toggleSearchVisibility = () => {
    setSearchVisible(!searchVisible);

    if (hashObj && hashObj.target === 'search') {
      hashObj.target = undefined;
      updateHash(hashObj, true);
    }
  };

  const handleCategoriesClick = () => {
    toggleCategoriesVisibility();
  };

  const handleCategoriesMouseEnterOrLeave = () => {
    // headerStackedListBreakpoint == '1000px', so trim the last two chars
    const headerStackedListBreakpointSize = headerStackedListBreakpoint.slice(
      0,
      -2,
    );
    if (window.innerWidth >= headerStackedListBreakpointSize) {
      toggleCategoriesVisibility();
    }
  };

  const handleClickOutside = () => {
    setCategoriesVisible(false);
  };

  const handleSearchClick = () => {
    toggleSearchVisibility();
  };

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const hasUserCookie = authService.hasUserCookie();
  const profile = data?.profile;

  return (
    <>
      <MyEventsProductMarketingModal onClose={toggleModal} show={showModal} />
      <HeaderMenuDiscovery
        hasUserCookie={hasUserCookie}
        profile={profile}
        onButtonClick={handleButtonClick}
        onCategoriesClick={handleCategoriesClick}
        onCategoriesMouseEnterOrLeave={handleCategoriesMouseEnterOrLeave}
        onMaskClick={handleButtonClick}
        onNavCloseClick={handleButtonClick}
        onNavLinkClick={handleButtonClick}
        onMyEventsClick={toggleModal}
        onSearchCloseClick={handleSearchClick}
        onSearchLinkClick={handleSearchClick}
        selectedLocale={props.selectedLocale}
        userSelectedLocale={props.userSelectedLocale}
        categoriesVisible={categoriesVisible}
        navVisible={navVisible}
        searchVisible={searchVisible}
        {...props}
      />
    </>
  );
};

const HeaderMenuDiscoveryContainerWithGraphQL = (props) => {
  const authService = useAuthService();
  return (
    <Query
      query={authService.loggedIn ? UserQueryPrivate : UserQueryPublicBasic}
      skip={!authService.getUserCookie()}
      variables={{ id: authService.getUserCookie() }}
    >
      {(gqlData) => <HeaderMenuDiscoveryContainer {...props} {...gqlData} />}
    </Query>
  );
};

export default HeaderMenuDiscoveryContainerWithGraphQL;
